"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ChangeRequestErrors;
(function (ChangeRequestErrors) {
    ChangeRequestErrors["ErrorCodeSalesForceDuplicate"] = "CHANGE_REQUEST__SALES_FORCE_DUPLICATE";
    ChangeRequestErrors["TaxIdInvalid"] = "5fddd98c-e343-4050-861a-0a3db226039d";
    ChangeRequestErrors["ViolationCodeDuplicateEmail"] = "e9fe394b-3ba7-49a1-bb77-1c7db8af60c8";
})(ChangeRequestErrors || (ChangeRequestErrors = {}));
exports.default = ChangeRequestErrors;
